export default __webpack_public_path__ + "static/media/источники_тональность.66d0454f.pdf";